import { makeAutoObservable, runInAction } from 'mobx'
import { md5 } from '@src/common/dependencies'
import { request } from '@/common'

/** 用于管理会话中文件的状态 */
class FileStore {
  // 存储文件的状态，key 是文件名的 md5
  // 值是文件的状态 https://geelib.qihoo.net/geelib/knowledgeShare?shorturl=552459091e65f36e57480d153d
  // 此外还有服务端的状态
  // error 解析失败
  // completed 解析完成
  // timeout 解析超时
  // illegality 文件违规
  fileStatusMap = {}
  // 服务端状态
  _assistant_chatdoc_server_default = {
    error: ['解析失败'],
    completed: ['解析完成'],
    illegality: ['文件违规'],
    timeout: ['解析超时'],
  }
  _assistant_chatdoc_params = {
    parsing: ['解析中'],
    splitting: ['文本切分中'],
    indexing: ['文本分块中'],
  }
  // 轮询超时
  timeout = 180
  // 用于判断是否停止轮询的状态 { cid, status: 1 启用轮询 2 正常停止轮询 3 中断轮询 }
  shouldStopMap = {}
  /** 在云控初始化时调用这个方法更新数据 */
  updateAssistantChatDocParams(data) {
    runInAction(() => {
      this.timeout = data.timeout || 180
      this._assistant_chatdoc_params = {
        ...this._assistant_chatdoc_params,
        ...data,
        ...this._assistant_chatdoc_server_default,
      }
    })
  }
  constructor() {
    window['File_Store'] = this
    makeAutoObservable(this)
  }
  /** 转换文件URL到md5，这是跟服务端的约定 */
  getFileMd5(fileURL) {
    return md5(fileURL)
  }
  getRandomElement(array) {
    if (!Array.isArray(array) || array.length === 0) {
      // throw new Error('Input must be a non-empty array')
      console.warn('>_<没有找到对应的文本解析状态!')
      return ''
    }
    const randomIndex = Math.floor(Math.random() * array.length)
    return array[randomIndex]
  }
  /**
   * 请求服务端获取当前会话中文件的解析状态，
   * cid当前会话id，msgId消息，files传入文件数组，文件名需要被处理为md5，才能跟服务端返回的文件一一对应
   */
  getFilesParsingAsync(cid, msgId, files) {
    return async (status) => {
      if (status === 3) {
        files.forEach(file => {
          file.md5 = this.getFileMd5(file.url)
          this.fileStatusMap[file.md5] = ""
        })
        return
      }

      request('/chat/doc/status', {
        method: 'post',
        data: {
          conversation_id: cid,
          message_id: msgId,
        }
      }).then(res => {
        if (res.code !== 0) return
        const data = res.data
        // 检查 data 数组里的每个元素是否都不包含 parsing, splitting, indexing
        const shouldStop = data.every(item => {
          return !['parsing', 'splitting', 'indexing'].includes(item.status)
        })
        if (shouldStop) {
          runInAction(() => {
            this.shouldStopMap[cid] = 2
          })
        }
        // 通过文件url的md5匹配服务端和对话的文件并更新状态
        if (!Array.isArray(data)) return
        files.forEach(file => {
          file.md5 = this.getFileMd5(file.url)
          data.forEach(item => {
            if (item.id !== file.md5) return
            const status = item.status
            const textArray = this._assistant_chatdoc_params[status] || []
            file.statusText = this.getRandomElement(textArray)
            runInAction(() => {
              if (file.statusText === '解析完成') {
                this.fileStatusMap[file.md5] = ""
              } else {
                this.fileStatusMap[file.md5] = file.statusText
              }
            })
          })
        })
      })
    }
  }
  // 停止所有轮询
  clearAllRecursive() {
    runInAction(() => {
      Object.keys(this.shouldStopMap).forEach(key => {
        this.shouldStopMap[key] = 2
      })
    })
  }
  // 中断所有轮询
  stopAllRecursive() {
    runInAction(() => {
      Object.keys(this.shouldStopMap).forEach(key => {
        this.shouldStopMap[key] = 3
      })
    })
  }
  /** 创建用于递归的方法 */
  createRecursiveFunction(callback, cid, secs = 0) {
    // 如果创建递归，那么可以判断是要启动轮询
    // 因为这种操作发生在发送消息之后
    this.shouldStopMap[cid] = 1
    const recursiveFunction = async () => {
      // 查询 shouldStopMap 如果状态为2则停止轮询
      if (secs >= this.timeout || this.shouldStopMap[cid] === 2) {
        console.log('Timeout reached or exceeded.');
        return;
      }
      // console.log(`Current secs: ${secs}`);
      // 调用回调函数
      // 3 状态 中止轮询，但是还要再执行一步：将3状态传入callback做特定交互
      if (this.shouldStopMap[cid] === 3) {
        await callback(3)
        return
      }
      // 正常运行
      await callback()
      const interval = 3
      // 更新 secs
      secs += interval;
      // 延迟 3 秒后再次执行
      setTimeout(recursiveFunction, interval * 1000);
    };
    return recursiveFunction
  }
}

const fileStore = new FileStore()

export default fileStore